// Modules
import styled from 'styled-components';

// Web Components
import { BiuDateBar } from '../../biu-web-components/src/components';

// Types
import { styledComponentProps } from '../../types/theme';

export const DateBarView = styled(BiuDateBar)`
	.biu-date-bar {
        width: 100%;
        @media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
            width: calc(100% - 40px);
         }
        .biu-date-bar__date-view {
            width: calc(100% / 9);
            @media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
                width: calc(100% / 5);
             }
             @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
                width: calc(100% / 3);
             }
        }
    }
`;
